import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { BaseDialogComponent } from '@helpers/base';
import { TranslateModule } from '@ngx-translate/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
    selector: 'prompt-dialog',
    templateUrl: './prompt.dialog.html',
    styleUrls: ['./dialog.scss'],
    standalone: true,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatToolbarModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        TranslateModule,
    ],
})
export class PromptDialog extends BaseDialogComponent implements OnInit {
    public title: string;
    public label: string;
    public value = '';
    public form: UntypedFormGroup;

    constructor(
        public dialogRef: MatDialogRef<PromptDialog>,
        public fb: UntypedFormBuilder,
    ) {
        super(dialogRef);
    }

    ngOnInit() {
        this.form = this.fb.group({
            prompt: [this.value, Validators.required],
        });
    }

    submit() {
        const value = this.form.value;

        this.dismiss(value.prompt);
    }
}
